import { RadioButtonGroup } from "@octopusdeploy/design-system-components";
import { withBoundField } from "~/components/form/BoundField/BoundField";
export const BoundRadioButtonGroup = withBoundField(RadioButtonGroup);
